import { gql } from '@apollo/client';
const GET_PRODUCT_SUSTAINABILITIES = gql `
  query GetProductSustainabilities($first: Int = 25, $after: String = "") {
    autocomplete {
      productSustainabilities(first: $first, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            name
            description
            thumbnail
          }
        }
      }
    }
  }
`;
export default GET_PRODUCT_SUSTAINABILITIES;
